import { clsx } from 'clsx';
import { FeedAuthorFilter } from '../model/feedFilter.types';

const SEGMENTS: { value: FeedAuthorFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'mine', label: 'My Posts' },
];

type Props = {
  value: FeedAuthorFilter;
  onChange: (value: FeedAuthorFilter) => void;
};

export const FeedFilterToggle = ({ value, onChange }: Props) => (
  <div
    role="group"
    aria-label="Filter posts by author"
    className="flex items-center gap-4"
  >
    {SEGMENTS.map((segment) => {
      const active = segment.value === value;
      return (
        <button
          key={segment.value}
          type="button"
          onClick={() => onChange(segment.value)}
          aria-pressed={active}
          className={clsx(
            'rounded-[10px] px-4 py-2 text-center text-base font-medium leading-6',
            active ? 'bg-[#EDE5FC] text-[#350584]' : 'text-[#131313]',
          )}
        >
          {segment.label}
        </button>
      );
    })}
  </div>
);
